import { cn } from '../../utils/helpers';
import { t } from '../../i18n';

export function Spinner({ className }: { className?: string }) {
  return (
    <svg className={cn('h-5 w-5 animate-spin', className)} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  );
}

export function PageLoader({ label = t('Načítava sa…') }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-secondary-500" role="status">
      <Spinner className="text-primary-600" />
      {label}
    </div>
  );
}
